// extracted by mini-css-extract-plugin
export default {"overlay":"positionAwareMenu_overlay__oAU5W"};